// 公共参数
export const common = state => state.common
// 用户验证信息
export const userData = state => state.user.userData
// 用户上传头像请求头
export const tyrzUploadPortraitHeaders = state => state.user.tyrzUploadPortraitHeaders



// WEBPACK FOOTER //
// ./src/store/getters.js